export const getQueryName = (query: string) => {
  const regex = /query\s+(\w+)\s*(\([^)]*\))?\s*{/;
  const match = regex.exec(query);
  if (match) {
    return match[1];
  }
  return null;
};
